<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
            <div class="card">
                <div class="card-header pb-0">
                    <div class="d-flex align-items-center">
                        <p class="mb-0">Ajustes de la empresa</p>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <label for="example-text-input" class="form-control-label"
                            >Nombre de la empresa</label
                            >
                            <argon-input type="text" v-model="company.name"/>
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label"
                            >Documento</label
                            >
                            <argon-input type="text" v-model="company.document"/>
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label"
                            >Nombre del administrador</label
                            >
                            <argon-input type="text" v-model="company.owner" />
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label"
                            >Ciudad</label
                            >
                            <input class="form-control" type="text" v-model="company.city"/>
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label"
                            >Departamento</label
                            >
                            <argon-input type="text" v-model="company.department" />
                        </div>
                        <div class="col-md-12">
                            <label for="example-text-input" class="form-control-label"
                            >Dirección</label
                            >
                            <argon-input type="text" v-model="company.address"/>
                        </div>
                    </div>
                    <hr class="horizontal dark" />
                    <div class="row">
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label"
                            >Teléfono</label
                            >
                            <input class="form-control" type="text" v-model="company.phone"/>
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label"
                            >Teléfono 2</label
                            >
                            <argon-input type="text" v-model="company.phone2" />
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label"
                            >Email</label
                            >
                            <input class="form-control" type="text" v-model="company.email"/>
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label"
                            >Web</label
                            >
                            <argon-input type="text" v-model="company.web" />
                        </div>
                    </div>
                    <argon-button
                    type="submit" 
                    class="mt-4"
                    variant="gradient"
                    color="info"
                    fullWidth
                    size="lg"
                    @click="updateCompany"
                    >Guardar</argon-button>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>

import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "axios";

export default {
    name: "company",
    data() {
        return {
            showMenu: false,
            company:{
                action:'edit',
                object:'company',
                id:null,
                name:null,
                city:null,
                department:null,
                address:null,
                web:null,
                email:null,
                phone:null,
                phone2:null,
                document:null,
                owner:null
            }
        };
    },
    components: {ArgonInput, ArgonButton },
    methods:{
        async fetch_company(config){
            let self=this;
            fetch(this.$store.state.apiURL+'?action=view&object=company&id=1', config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result);
                
                this.company=result.company;
                this.company['action']='edit';
                this.company['object']='company';
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        updateCompany(){
            let self= this;
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"Authorization": `Bearer ${token}`}};
            console.log(this.company)
            axios.post(this.$store.state.apiURL, this.company, config)
            .then((result)=>{
                console.log(result);
                self.$swal({
                    title: 'Actualización de datos',
                    text: 'Se Actualizó la información de la empresa de manera satisfactoria',
                    type: 'success',
                    icon:'success',
                    showCancelButton: false,
                    confirmButtonColor:'#bf4f51',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    self.$router.push('/');
                });
            })
        }
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"Authorization": `Bearer ${token}`}};
        this.fetch_company(config);
    },
    beforeMount() {

    },
    beforeUnmount() {

    }
};
</script>